// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldCheckboxGroup_root__3nsPs","list":"FieldCheckboxGroup_list__9tk_c","twoColumns":"FieldCheckboxGroup_twoColumns__QDm2T","item":"FieldCheckboxGroup_item__374Z6"};